const orgType = {
  SPECIFIC_ORG_ORDINARY: [
    { text: '非金融机构法人', value: '非金融机构法人' },
    { text: '机关法人', value: '机关法人' },
    { text: '事业单位法人', value: '事业单位法人' },
    { text: '社会团体法人', value: '社会团体法人' },
    { text: '非金融非法人机构', value: '非金融非法人机构' },
    { text: '其他境内金融机构', value: '其他境内金融机构' },
    { text: '境外代理人', value: '境外代理人' },
    { text: '境外金融机构', value: '境外金融机构' },
    { text: '外国战略投资者', value: '外国战略投资者' },
    { text: '境外非金融机构', value: '境外非金融机构' },
    { text: '其他', value: '其他' },
  ],
  SPECIFIC_ORG_PROFESSION: [
    { text: '非金融机构法人', value: '非金融机构法人' },
    { text: '机关法人', value: '机关法人' },
    { text: '事业单位法人', value: '事业单位法人' },
    { text: '社会团体法人', value: '社会团体法人' },
    { text: '非金融非法人机构', value: '非金融非法人机构' },
    { text: '其他境内金融机构', value: '其他境内金融机构' },
    { text: '境外代理人', value: '境外代理人' },
    { text: '境外金融机构', value: '境外金融机构' },
    { text: '外国战略投资者', value: '外国战略投资者' },
    { text: '境外非金融机构', value: '境外非金融机构' },
    { text: '其他', value: '其他' },
  ],
  SPECIFIC_ORG_ORG: [
    { text: '证券公司', value: '证券公司' },
    { text: '期货公司', value: '期货公司' },
    { text: '基金管理公司', value: '基金管理公司' },
    { text: '基金管理公司子公司', value: '基金管理公司子公司' },
    { text: '银行', value: '银行' },
    { text: '保险公司', value: '保险公司' },
    { text: '信托公司', value: '信托公司' },
    { text: '财务公司', value: '财务公司' },
    { text: '证券公司子公司', value: '证券公司子公司' },
    { text: '期货公司子公司', value: '期货公司子公司' },
    { text: '私募基金管理人', value: '私募基金管理人' },
  ],
  SPECIFIC_ORG_PRACTITIONERS: [
    { text: '私募基金管理人', value: '私募基金管理人' },
  ],
};
export default orgType;
